import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/shared/hooks/useAuthStore.ts';

const ERROR_MESSAGES: Record<string, string> = {
  domain_not_allowed: 'Acesso restrito a colaboradores Woli (@woli.com.br).',
  google_userinfo_failed: 'Erro ao obter dados do Google. Tente novamente.',
  oauth_failed: 'Erro na autenticação. Tente novamente.',
  session_expired: 'Sessão expirada. Faça login novamente.',
  user_inactive: 'Seu acesso está aguardando aprovação de um administrador.',
};

export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { accessToken } = useAuthStore();

  const error = searchParams.get('error');

  // Se já está autenticado, redirecionar para /admin
  useEffect(() => {
    if (accessToken) {
      navigate('/admin', { replace: true });
    }
  }, [accessToken, navigate]);

  const handleLogin = () => {
    window.location.href = `${import.meta.env.VITE_API_BASE_URL || ''}/api/auth/google`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-sm space-y-6 rounded-xl bg-white p-8 shadow-lg dark:bg-gray-800">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Woli Uptime Monitor
          </h1>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Painel administrativo
          </p>
        </div>

        {error && (
          <div
            className={`rounded-lg border p-3 text-sm ${
              error === 'user_inactive'
                ? 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-900/20 dark:text-amber-400'
                : 'border-red-200 bg-red-50 text-red-700 dark:border-red-800 dark:bg-red-900/20 dark:text-red-400'
            }`}
          >
            {ERROR_MESSAGES[error] || 'Erro desconhecido. Tente novamente.'}
          </div>
        )}

        <button
          onClick={handleLogin}
          className="flex w-full items-center justify-center gap-3 rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
          Entrar com Google
        </button>

        <p className="text-center text-xs text-gray-400 dark:text-gray-500">
          Acesso restrito a colaboradores @woli.com.br
        </p>
      </div>
    </div>
  );
}
